<template>
  <LayOut></LayOut>
</template>

<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};

import LayOut from "./components/LayOut.vue";

export default {
  name: "App",
  components: {
    LayOut,
  },
  created() {
    this.checkReferrer();
  },
  methods: {
    checkReferrer() {
      const referrer = document.referrer;
      if (referrer) {
        if (referrer.includes("baidu.com")) {
          this.$store.commit("setSource", 1);
        } else if (referrer.includes("bing.com")) {
          this.$store.commit("setSource", 2);
        } else {
          this.$store.commit("setSource", null);
        }
      } else {
        this.$store.commit("setSource", null);
      }
    },
  },
};
</script>


